import { useEffect, useState } from "react";
import { Download, Share, PlusSquare } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { isIOS, isStandalone } from "@/lib/push";

let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
  window.dispatchEvent(new Event("aurora-installable"));
});

export const InstallAppButton = ({ testId = "install-app-button" }) => {
  const [canPrompt, setCanPrompt] = useState(!!deferred);
  const [iosHelp, setIosHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const on = () => setCanPrompt(true);
    const done = () => setInstalled(true);
    window.addEventListener("aurora-installable", on);
    window.addEventListener("appinstalled", done);
    return () => {
      window.removeEventListener("aurora-installable", on);
      window.removeEventListener("appinstalled", done);
    };
  }, []);

  if (installed || (!canPrompt && !isIOS())) return null;

  const install = async () => {
    if (isIOS()) return setIosHelp(true);
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setInstalled(true);
    deferred = null;
    setCanPrompt(false);
  };

  return (
    <>
      <button onClick={install} className="btn-ghost !h-9 !px-3 text-xs" data-testid={testId} title="Install SpeechFlow on your Home Screen">
        <Download size={14} /><span className="hidden sm:inline">Install app</span>
      </button>
      <Dialog open={iosHelp} onOpenChange={setIosHelp}>
        <DialogContent className="max-w-sm rounded-none" data-testid="install-ios-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Add SpeechFlow to your Home Screen</DialogTitle>
            <DialogDescription>Use SpeechFlow like a real app, with notifications.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><span className="font-mono text-[color:var(--au-green)]">01</span> Tap <Share size={16} className="inline" /> <b>Share</b> in Safari&apos;s toolbar</li>
            <li className="flex items-center gap-3"><span className="font-mono text-[color:var(--au-green)]">02</span> Choose <PlusSquare size={16} className="inline" /> <b>Add to Home Screen</b></li>
            <li className="flex items-center gap-3"><span className="font-mono text-[color:var(--au-green)]">03</span> Open SpeechFlow from the new icon and enable notifications</li>
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
